import request from "_private/utils/request";

// 查询分页数据
export function FetchStorageTaskByPage(data) {
  return request({
    url: "/board/warehouseMonitor/findByPage",
    method: "post",
    headers: { type: "json" },
    data
  });
}
// 查询tabInfo
export function FetchStorageTaskTabInfo(data) {
  return request({
    url: "/board/warehouseMonitor/tabInfo",
    method: "post",
    headers: { type: "json" },
    data
  });
}
